<template>
  <div :class="wrapperClasses">
    <svg
      :class="spinnerClasses"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span v-if="label" :class="labelClasses">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseSpinner',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'white', 'gray'].includes(value)
    },
    label: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapperClasses() {
      return [
        this.inline ? 'inline-flex items-center' : 'flex items-center',
        this.center ? 'justify-center' : '',
        this.overlay ? 'fixed inset-0 bg-white bg-opacity-75 z-50 flex items-center justify-center' : '',
        this.label ? 'gap-2' : ''
      ]
    },
    spinnerClasses() {
      return [
        'animate-spin',
        this.sizeClasses,
        this.variantClasses
      ]
    },
    sizeClasses() {
      const sizes = {
        xs: 'h-3 w-3',
        sm: 'h-4 w-4',
        md: 'h-6 w-6',
        lg: 'h-8 w-8',
        xl: 'h-12 w-12'
      }
      return sizes[this.size]
    },
    variantClasses() {
      const variants = {
        primary: 'text-primary',
        secondary: 'text-secondary',
        white: 'text-white',
        gray: 'text-gray-500'
      }
      return variants[this.variant]
    },
    labelClasses() {
      const sizes = {
        xs: 'text-xs',
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
        xl: 'text-xl'
      }
      return [
        sizes[this.size],
        this.variantClasses
      ]
    }
  }
}
</script>
